// When the chat list tells of the connection ("Bağlanıyor…", "Yeniden bağlanıyor…", offline).

/** This page has been connected at least once: a drop is then told sooner than the first start. */
let everConnected = false;

/** Told by the chat store at every connect (the list may not be on screen then). */
export function noteConnected(): void {
  everConnected = true;
}

/** For tests. */
export function resetConnectionLabel(): void {
  everConnected = false;
}

/**
 * How long a connection state must last before it is told (null: it is not). A drop after having been connected
 * shows after 2 s, so a real outage never hides; the first start after 4 s (the chats come over REST meanwhile, so a
 * slow start must not look like a fault); being offline after 1.5 s.
 */
export function connectionLabelDelay(connection: string): number | null {
  if (connection === 'connected') {
    everConnected = true;
    return null;
  }
  if (connection === 'offline') return 1500;
  return everConnected ? 2000 : 4000;
}
